import { render, staticRenderFns } from "./TemplateGroup.vue?vue&type=template&id=818bc474&scoped=true"
import script from "./TemplateGroup.vue?vue&type=script&lang=js"
export * from "./TemplateGroup.vue?vue&type=script&lang=js"
import style0 from "./TemplateGroup.vue?vue&type=style&index=0&id=818bc474&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818bc474",
  null
  
)

export default component.exports